import { Helmet } from "react-helmet-async"
import { Container, createStyles } from "@mantine/core"
import { PageTitle } from "shared/ui/PageTitle"
import { ArticleCategoryFilter } from "features/article"
import { ArticleSearch, ArticleList } from "features/article"
import React from "react"

// ----------------------------------------------------------------------

const useStyles = createStyles((theme) => ({
  container: {
    paddingTop: "4rem",
    paddingBottom: "4rem",

    [theme.fn.smallerThan("md")]: {
      paddingTop: "3rem",
      paddingBottom: "3rem",
    },

    [theme.fn.smallerThan("xs")]: {
      paddingTop: "1.5rem",
      paddingBottom: "1.5rem",
    },
  },
}))

// ----------------------------------------------------------------------

export function ArticleListPage(): React.JSX.Element {
  const { classes } = useStyles()
  const url = new URL(window.location.href)

  return (
    <>
      <Helmet>
        <title>BodyCoach - блог</title>
        <meta property="og:title" content="BodyCoach - блог"/>

        <meta name="description"
              content="Полезные статьи о фитнесе от Body Coach"/>
        <meta property="og:description"
              content="Полезные статьи о фитнесе от Body Coach"/>

        <meta property="og:url" content={url.href}/>
        <link rel="canonical" href={url.href}/>
        <meta property="og:site_name" content={url.host}/>
        <meta name="robots" content="index, follow"/>

        <meta name="keywords"
              content="блог боди коуч, боди коуч статьи, body coach материалы, материалы бодикоч, гармональная система, нутрициология, лфк и реабилитация, тренировочный процесс, групповые направления, психология и продажи"/>
      </Helmet>

      <Container size="xl" className={classes.container}>
        <PageTitle title="Полезные статьи о фитнесе"/>

        <ArticleSearch variant="filled" radius="xl" mb="xl" size="md"/>

        <ArticleCategoryFilter/>

        <ArticleList/>
      </Container>
    </>
  )
}
